import type { UploadingOptions } from '@/services/types/file-uploader.types';
import type { FileVersion } from '@/services/types/file.types';

export abstract class BaseFileUploader {
  protected readonly _version: FileVersion;

  protected constructor(version: FileVersion) {
    this._version = version;
  }

  public abstract upload(options: UploadingOptions): Promise<unknown>;
}
